import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { ApiService } from 'src/app/api.service';
import { OrganisationService } from 'src/app/organisation.service';
import { RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterLink, FormsModule, AsyncPipe]
})
export class ProfileComponent implements OnInit {
  hasApiError = false;
  apiError: string;
  apiErrorDetails: string;
  loggedInUserSocialId: string;
  revealApiKey = false;

  taeUser: any = null;
  taeOrgs: Array<any>;

  createNewOrgName: string = "";
  joinTargetOrgId: string = "";

  constructor(
    public auth: AuthService,
    private api: ApiService,
    private orgService: OrganisationService,
  ) { }

  ngOnInit() {

    this.selectOrg({});

    this.hasApiError = false;
    this.auth.user$.subscribe({
      next: (profile) => {

        this.api.getUsersId$(profile.sub).subscribe({
          next: (user) => {
            this.taeUser = user;
          }
        });

        this.api.getUsersIdOrganisations$(profile.sub).subscribe({
          next: (orgs) => {
            this.taeOrgs = orgs;
          }
        });

      }
    });
  }

  createOrg() {
    this.hasApiError = false;
    var newOrg = { name: this.createNewOrgName };
    this.api.postOrganisations$(newOrg).subscribe({
      next: () => {
        this.auth.user$.subscribe({
          next: (profile) => {
            this.api.getUsersIdOrganisations$(profile.sub).subscribe({
              next: (orgs) => {
                this.taeOrgs = orgs;
              }
            })
          }
        });
      },
      error: (err) => this.handleError(err),
    });
    this.createNewOrgName = "";
  }

  updateOrg(org: any) {
    this.hasApiError = false;

    this.api.putOrganisationsId$(org.id, org).subscribe({
      next: () => { }
    });
  }

  joinOrg() {
    this.hasApiError = false;
    // Join the org
    this.api.putOrganisationsIdJoin$(this.joinTargetOrgId).subscribe({
      next: () => {
        this.auth.user$.subscribe({
          next: (profile) => {
            this.api.getUsersIdOrganisations$(profile.sub).subscribe({
              next: (orgs) => {
                this.taeOrgs = orgs;
              }
            })
          }
        });
      },
      error: (err) => this.handleError(err),
    });
    this.joinTargetOrgId = "";
  }

  leaveOrg(org: any) {

    var msg = "Are you sure you want to leave " + org.name + "?  " +
      "If you are the last to leave, " + org.name +
      " will be deleted, along with its jobs and materials.";

    var doLeave = confirm(msg);
    if (!doLeave) {
      return;
    }

    this.hasApiError = false;

    // Leave the org
    this.api.putOrganisationsIdLeave$(org.id).subscribe({
      next: () => {
        this.auth.user$.subscribe({
          next: (profile) => {
            this.api.getUsersIdOrganisations$(profile.sub).subscribe({
              next: (orgs) => {
                this.taeOrgs = orgs;
              }
            })
          }
        });
      },
      error: (err) => this.handleError(err),
    });
  }

  requestCpuTime(org: any) {

    var msg = "A request will be sent to Tin Arm Engineering to contact you about a subscription.";

    var doSend = confirm(msg);
    if (!doSend) {
      return;
    }

    this.hasApiError = false;

    this.api.postRequestCpuTimeMessage$(org).subscribe({
      next: () => { },
      error: (err) => this.handleError(err),
    });
  }

  toggleRevealApiKey() {

    // If not currently displayed
    if (!this.revealApiKey) {
      var msg = "Reveal your API key?"
      var doReveal = confirm(msg);
      if (!doReveal) {
        return;
      }
    }

    this.revealApiKey = !this.revealApiKey;
  }

  toggleEditOrg(org: any) {
    org.editing = !org.editing;
  }

  selectOrg(org: any) {
    this.orgService.setOrg(org);
  }

  handleError(error: HttpErrorResponse): void {
    this.hasApiError = true;
    this.apiError = error.message

    if (error.error) {
      this.apiError += ": " + error.error;
      this.apiErrorDetails = error.error;
    }
  }
}
